/***
 * 来源类型
 */

import React from 'react';
import { getData } from '@util';
import { Select } from 'antd';
import { API_POST_GETSUPPLIERFILE_DETAIL_NEW } from '@api';
class SourceType extends React.PureComponent {
  state = {
    listData: [],
    iconType: false,
  };

  componentDidMount() {
    this.getPurchaseOrgCode();
  }

  // 获取来源类型
  getPurchaseOrgCode = () => {
    getData({ api: API_POST_GETSUPPLIERFILE_DETAIL_NEW, searchParams: { type: 1 } }).then(res => {
      const { data } = res;
      this.setState({
        listData: [...data],
      });
    });
  };

  render() {
    const { listData } = this.state;
    const { isSingleSelect } = this.props;
    return (
      <Select
        allowClear
        showArrow
        mode={!isSingleSelect && 'multiple'}
        placeholder="请选择"
        {...this.props}>
        {listData.map(item => (
          <Select.Option key={item.key} value={`${item.fileName}`}>
            {item.fileName}
          </Select.Option>
        ))}
      </Select>
    );
  }
}

export default SourceType;
